angular.module("app").component("passwordRecoverComponent", {
  templateUrl: "app/components/password-recover/password-recover.tmpl.html",
  controller: function ($state, $http, appConfig, $stateParams) {
    var self = this;
    this.successRequest = false;
    this.password = "";
    this.passwordConfirm = "";
    this.error = false;
    this.type = $stateParams.token[0] || "r";
    this.token = $stateParams.token;

    this.busy = false;

    this.onSendLoginClick = function () {
      if (self.busy) return;
      self.error = false;
      if (!self.password || !self.passwordConfirm) {
        self.error = "Please fill in both password fields.";
        return;
      }
      if (self.password.length < 8) {
        self.error = "Use at least 8 characters.";
        return;
      }
      if (self.password !== self.passwordConfirm) {
        self.error = "The two passwords don't match.";
        return;
      }
      self.busy = true;
      const params = {
        password: {
          new_password: self.password,
          password_confirmation: self.passwordConfirm,
          reset_password_token: self.token
        }
      };
      $http
        .put(appConfig.dashboardServiceUrl + "api/users/update_password_with_token", params)
        .then(function (res) {
          if (res.data && res.data.success) {
            self.successRequest = true;
          } else {
            self.error = "This link has expired or was already used. Send a new one below.";
          }
        })
        .catch(function (err) {
          const e = err && err.data && err.data.errors;
          self.error = e ? [].concat(e).join(" ") : "This link has expired or was already used. Send a new one below.";
        })
        .finally(function () { self.busy = false; });
    };
  },
});
